import * as React from "react";
const SvgNotifications = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M23.9997 21V14.3333C23.9997 10.24 21.8263 6.81333 17.9997 5.90667V5C17.9997 3.89333 17.1063 3 15.9997 3C14.893 3 13.9997 3.89333 13.9997 5V5.90667C10.1863 6.81333 7.99967 10.2267 7.99967 14.3333V21L5.33301 23.6667V25H26.6663V23.6667L23.9997 21ZM15.9997 29C17.4663 29 18.6663 27.8 18.6663 26.3333H13.333C13.333 27.8 14.533 29 15.9997 29ZM10.6663 22.3333H21.333V14.3333C21.333 11.0267 19.3197 8.33333 15.9997 8.33333C12.6797 8.33333 10.6663 11.0267 10.6663 14.3333V22.3333Z",
	fill: "currentColor"
}));
export default SvgNotifications;
